<template>
  <div class="subject-score-analysis">
    <!-- <el-table :data="tableData" border style="width: 100%" height="calc(100vh - 260px)">
      <el-table-column prop="scoreRange" label="各科成绩分布" width="150"></el-table-column>
      <el-table-column prop="course1" label="语文"></el-table-column>
      <el-table-column prop="course2" label="数学"></el-table-column>
      <el-table-column prop="course3" label="英语"></el-table-column>
      <el-table-column prop="courseName" label="科目"></el-table-column>
      <el-table-column prop="examNumber" label="考试人数"></el-table-column>
      <el-table-column prop="averageScore" label="平均分"></el-table-column>
      <el-table-column prop="failCount" label="不及格人数"></el-table-column>
      <el-table-column prop="passCount" label="及格人数"></el-table-column>
      <el-table-column prop="passRate" label="合格率"></el-table-column>
      <el-table-column prop="excellentCount" label="优良人数"></el-table-column>
      <el-table-column prop="excellentRate" label="优良率"></el-table-column>
      <el-table-column prop="highestScore" label="最高分"></el-table-column>
      <el-table-column prop="lowestScore" label="最低分"></el-table-column>
      <el-table-column v-for="(value, key) in scoreRanges" :key="key" :label="key">
        <template slot-scope="scope">
          {{ scope.row.branchSegments[key] }}
        </template>
</el-table-column>
</el-table> -->
    <el-table :data="tableData" border style="width: 100%" height="calc(100vh - 260px)">
      <!-- 固定的第一列 -->
      <el-table-column prop="scoreRange" label="成绩分布" width="150"></el-table-column>
      <!-- 动态生成课程列 -->
      <el-table-column v-for="(courseName, index) in courseNames" :key="index" :label="courseName">
        <template slot-scope="scope">
          {{ scope.row[courseName] != -1 ? scope.row[courseName] : '-' }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: ['courseScoreAnalysisList'],
  data() {
    return {
      // tableData: [
      //   { scoreRange: '考试人数', range: 'examNumber', course1: 0, course2: 0, course3: 0 },
      //   { scoreRange: '平均分', range: 'averageScore', course1: 0, course2: 0, course3: 0 },
      //   { scoreRange: '不及格人数', range: 'failCount', course1: 0, course2: 0, course3: 0 },
      //   { scoreRange: '及格人数', range: 'passCount', course1: 0, course2: 0, course3: 0 },
      //   { scoreRange: '合格率', range: 'passRate', course1: 0, course2: 0, course3: 0 },
      //   { scoreRange: '优良人数', range: 'excellentCount', course1: 0, course2: 0, course3: 0 },
      //   { scoreRange: '优良率', range: 'excellentRate', course1: 0, course2: 0, course3: 0 },
      //   { scoreRange: '最高分', range: 'highestScore', course1: 0, course2: 0, course3: 0 },
      //   { scoreRange: '最低分', range: 'lowestScore', course1: 0, course2: 0, course3: 0 },
      // ]
    };
  },
  computed: {
    // 将 branchSegments 转换为可以用于表格列的数组
    // scoreRanges() {
    //   if (this.courseScoreAnalysisList.length === 0) return {};

    //   // 假设所有项都有相同的 branchSegments 结构
    //   const firstItemBranchSegments = this.courseScoreAnalysisList[0].branchSegments;
    //   return firstItemBranchSegments;
    // },
    // 提取所有课程名称用于动态生成列
    courseNames() {
      return this.courseScoreAnalysisList.map(item => item.courseName);
    },
    tableData() {
      const staticFields = [
        { scoreRange: '考试人数', range: 'examNumber' },
        { scoreRange: '平均分', range: 'averageScore' },
        { scoreRange: '不及格人数', range: 'failCount' },
        { scoreRange: '及格人数', range: 'passCount' },
        { scoreRange: '合格率', range: 'passRate' },
        { scoreRange: '优良人数', range: 'excellentCount' },
        { scoreRange: '优良率', range: 'excellentRate' },
        { scoreRange: '最高分', range: 'highestScore' },
        { scoreRange: '最低分', range: 'lowestScore' }
      ];

      // 获取所有的 branchSegments 键
      const branchSegmentsKeys = Object.keys(this.courseScoreAnalysisList[0]?.branchSegments || {});

      // 添加 branchSegments 的字段到 staticFields
      branchSegmentsKeys.forEach(key => {
        staticFields.push({ scoreRange: key, range: key });
      });

      // 创建转置后的数据结构
      const transposed = staticFields.map(field => {
        const row = {
          scoreRange: field.scoreRange, ...this.courseScoreAnalysisList.reduce((acc, curr) => {
            acc[curr.courseName] = curr[field.range] !== undefined ? curr[field.range] : curr.branchSegments[field.range];
            return acc;
          }, {})
        };
        return row;
      });

      return transposed;
    }
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import "./subjectScoreAnalysis.scss";
</style>